import { useEffect, useState } from "react";
import { api } from "../api";
import { CheckCircle2 } from "lucide-react";

const Block = ({ title, value }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-6">
    <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-brand-teal">{title}</h3>
    <p className="mt-2 text-[15px] leading-relaxed text-brand-navy whitespace-pre-wrap">{value || "—"}</p>
  </div>
);

export default function PatientCarePlan() {
  const [plan, setPlan] = useState(undefined);

  useEffect(() => {
    api.get("/patient/careplan").then((r) => setPlan(r.data.care_plan)).catch(() => setPlan(null));
  }, []);

  if (plan === undefined) return <p className="text-slate-500 font-semibold">Loading your care plan…</p>;

  return (
    <div data-testid="patient-care-plan">
      <h1 className="font-display text-3xl md:text-4xl text-brand-navy">My Care Plan</h1>
      <p className="mt-2 text-[15px] text-slate-600">The personalized plan our office team has prepared for your care.</p>

      {plan === null ? (
        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-10 text-center text-slate-500">
          Your care plan is being prepared by our office team. Please check back soon or call us with any questions.
        </div>
      ) : (
        <div className="mt-8 space-y-5">
          <div className="rounded-2xl border border-slate-200 bg-white p-6">
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-brand-teal">Your Care Services</h3>
            <ul className="mt-3 space-y-2">
              {(plan.services || []).length === 0 && <li className="text-[15px] text-slate-500">—</li>}
              {(plan.services || []).map((s) => (
                <li key={s} className="flex items-start gap-2.5 text-[15px] font-semibold text-brand-navy">
                  <CheckCircle2 className="h-5 w-5 mt-0.5 shrink-0 text-brand-teal" strokeWidth={1.8} /> {s}
                </li>
              ))}
            </ul>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <Block title="Care Instructions" value={plan.instructions} />
            <Block title="Your Preferences" value={plan.preferences} />
            <Block title="Important Considerations" value={plan.considerations} />
            <Block title="Mobility & Safety" value={plan.mobility_safety} />
            <Block title="Visit Frequency" value={plan.visit_frequency} />
            <Block title="Preferred Days & Times" value={[plan.preferred_days, plan.preferred_times].filter(Boolean).join(" · ")} />
          </div>
        </div>
      )}
    </div>
  );
}
